import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
  IconButton
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { Close } from "@mui/icons-material"; 

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmModal = ({
  open,
  setOpen,
  onclick,
}: {
  open: boolean;
  setOpen: any;
  onclick: any;
}) => {
  const handleClose = () => {
    setOpen();
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={"sm"}
    >
             <IconButton
        aria-label="close"
        onClick={handleClose}
        size="small"
        sx={{
          position: 'absolute',
          right: 2,
          top: 2,
      
        }}
      >
        <Close sx={{color : "gray"}} />
      </IconButton>
      <DialogContent sx={{ p: 4 }}>
        There is already an file uploaded with this name. Do you wish to
        overwrite this file?
      </DialogContent>
      <DialogActions
        sx={{
          mb: 2,
          mr: 2,
        }}
      >
        <Button variant="contained" color="success" onClick={onclick}>
          Overwrite
        </Button>
        <Button variant="outlined" color="error" onClick={handleClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
